import type { ReportEvent, ReportEventOrderReference } from '@/types/report';
import { moveOrderedItem, type ReportOrderPlacement } from './moveOrderedItem';

function isReferencedEvent(
    event: ReportEvent,
    reference: ReportEventOrderReference,
): boolean {
    return event.id === reference.id && event.eventType === reference.eventType;
}

export function moveReportEvent(
    events: ReportEvent[],
    source: ReportEventOrderReference,
    target: ReportEventOrderReference,
    placement: ReportOrderPlacement,
): ReportEvent[] {
    return moveOrderedItem(
        events,
        (event) => isReferencedEvent(event, source),
        (event) => isReferencedEvent(event, target),
        placement,
    );
}
